import { AuthError } from "firebase/auth";

export function isAuthError(value: any): value is AuthError {
  const code = value?.code;
  return typeof code === "string" && code.startsWith("auth/");
}

// Error codes can be found at
// https://firebase.google.com/docs/reference/js/v8/firebase.auth.Error#code
export const handleErrorMessage = (error: unknown) => {
  console.log("handling error message for: ", error);
  const customError = "Oops, something went wrong. Please give it another try.";

  if (!isAuthError(error)) return customError;

  switch (error.code) {
    case "auth/user-not-found":
    case "auth/wrong-password":
      return "Hmmmm... We don't seem to have a record of that username/password combination.";
    case "auth/network-request-failed":
      return "Uh oh, we seem to have experienced a network error. Please try again.";
    case "auth/too-many-requests":
      return "There's been a few too many requests from this device. Please wait a few minutes and then try again.";
    case "auth/user-token-expired": // fallthrough
    case "auth/invalid-user-token":
      return "Looks like it's been a while since you've been authenticated, please sign in again.";
    case "auth/weak-password":
      return "Come on now, we need you to use a stronger password than that. Something with at least 6 characters would be great.";
    case "auth/invalid-action-code":
      return "The reset password code provided has already been used or is no longer valid.";
    case "auth/invalid-verification-code":
      return "The verification code is invalid. Please try again.";
    case "auth/missing-verification-code":
      return "The verification code is missing. Please try again.";
    default:
      console.log("Unhandled auth error code: ", error.code);
      return customError;
  }
};
